// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ybVBgfOiuWZJtD {
  font: var(--ds-font-body, 400 14px / 20px -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-display: swap;
  display: inline-flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  padding: 6px 12px;
  border-radius: var(--ds-radius-small, 3px);
  text-decoration: none;
  white-space: normal;
  cursor: pointer;
  border: none;
  background-color: var(--ds-background-neutral, #091e420f);
  box-shadow: none;
  color: var(--ds-text, #172b4d);
  font-weight: var(--ds-font-weight-medium, 500);
  transition-property: background-color, border-color, box-shadow;
  transition-duration: 85ms;
  transition-timing-function: ease;
}
.ybVBgfOiuWZJtD .HRDK8sNF4Ja3BM [role='img'] > svg,
.ybVBgfOiuWZJtD .cNqZwdypYCTs_6 [role='img'] > svg,
.ybVBgfOiuWZJtD .r1ljm7etlgUs0w [role='img'] > svg,
.ybVBgfOiuWZJtD .HRDK8sNF4Ja3BM svg[role='presentation'],
.ybVBgfOiuWZJtD .cNqZwdypYCTs_6 svg[role='presentation'],
.ybVBgfOiuWZJtD .r1ljm7etlgUs0w svg[role='presentation'] {
  /* stylelint-disable-next-line declaration-no-important */
  color: unset !important;
}
.ybVBgfOiuWZJtD .HRDK8sNF4Ja3BM {
  flex-shrink: 0;
  margin-right: var(--ds-space-100, 8px);
}
.ybVBgfOiuWZJtD .cNqZwdypYCTs_6 {
  flex-shrink: 0;
  margin-left: var(--ds-space-050, 4px);
}
.Yt_v_LmarJM9ZS {
  padding: var(--ds-space-075, 6px);
}
.ybVBgfOiuWZJtD:hover {
  border: none;
  background-color: var(--ds-background-neutral-hovered, #091e4224);
  box-shadow: none;
  color: var(--ds-text, #172b4d);
  text-decoration: none;
}
.ybVBgfOiuWZJtD:active {
  border: none;
  outline: 0;
  background-color: var(--ds-background-neutral-pressed, #091e424f);
  box-shadow: none;
  color: var(--ds-text, #172b4d);
}
.ybVBgfOiuWZJtD:active .B9_M57XSOL8YuV {
  color: var(--ds-text, #172b4d);
}
.ybVBgfOiuWZJtD:active svg circle {
  stroke: var(--ds-text, #172b4d);
}
.ybVBgfOiuWZJtD:focus-visible {
  outline: var(--ds-border-focused, #388bff) auto 2px;
  outline-offset: 2px;
}
.mac .ybVBgfOiuWZJtD:focus-visible {
  outline-color: -webkit-focus-ring-color;
}
.ybVBgfOiuWZJtD:focus-visible .mac.firefox {
  outline-color: AccentColor;
}
._St8_YSRMkLv07:focus {
  outline: var(--ds-border-focused, #388bff) auto 2px;
  outline-offset: 2px;
}
.mac ._St8_YSRMkLv07:focus {
  outline-color: -webkit-focus-ring-color;
}
._St8_YSRMkLv07:focus .mac.firefox {
  outline-color: AccentColor;
}
._St8_YSRMkLv07:focus:not(.jtCJZNTEQmaYhu) {
  outline: 0;
}
.suFfYx_LyIuG8T,
.ybVBgfOiuWZJtD:disabled,
.suFfYx_LyIuG8T:hover,
.ybVBgfOiuWZJtD:disabled:hover,
.suFfYx_LyIuG8T:active,
.ybVBgfOiuWZJtD:disabled:active {
  border: none;
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: none;
  color: var(--ds-text-disabled, #091e424f);
  cursor: not-allowed;
}
.suFfYx_LyIuG8T .HRDK8sNF4Ja3BM [role='img'] > svg,
.ybVBgfOiuWZJtD:disabled .HRDK8sNF4Ja3BM [role='img'] > svg,
.suFfYx_LyIuG8T:hover .HRDK8sNF4Ja3BM [role='img'] > svg,
.ybVBgfOiuWZJtD:disabled:hover .HRDK8sNF4Ja3BM [role='img'] > svg,
.suFfYx_LyIuG8T:active .HRDK8sNF4Ja3BM [role='img'] > svg,
.ybVBgfOiuWZJtD:disabled:active .HRDK8sNF4Ja3BM [role='img'] > svg,
.suFfYx_LyIuG8T .cNqZwdypYCTs_6 [role='img'] > svg,
.ybVBgfOiuWZJtD:disabled .cNqZwdypYCTs_6 [role='img'] > svg,
.suFfYx_LyIuG8T:hover .cNqZwdypYCTs_6 [role='img'] > svg,
.ybVBgfOiuWZJtD:disabled:hover .cNqZwdypYCTs_6 [role='img'] > svg,
.suFfYx_LyIuG8T:active .cNqZwdypYCTs_6 [role='img'] > svg,
.ybVBgfOiuWZJtD:disabled:active .cNqZwdypYCTs_6 [role='img'] > svg,
.suFfYx_LyIuG8T .r1ljm7etlgUs0w [role='img'] > svg,
.ybVBgfOiuWZJtD:disabled .r1ljm7etlgUs0w [role='img'] > svg,
.suFfYx_LyIuG8T:hover .r1ljm7etlgUs0w [role='img'] > svg,
.ybVBgfOiuWZJtD:disabled:hover .r1ljm7etlgUs0w [role='img'] > svg,
.suFfYx_LyIuG8T:active .r1ljm7etlgUs0w [role='img'] > svg,
.ybVBgfOiuWZJtD:disabled:active .r1ljm7etlgUs0w [role='img'] > svg,
.suFfYx_LyIuG8T .HRDK8sNF4Ja3BM svg[role='presentation'],
.ybVBgfOiuWZJtD:disabled .HRDK8sNF4Ja3BM svg[role='presentation'],
.suFfYx_LyIuG8T:hover .HRDK8sNF4Ja3BM svg[role='presentation'],
.ybVBgfOiuWZJtD:disabled:hover .HRDK8sNF4Ja3BM svg[role='presentation'],
.suFfYx_LyIuG8T:active .HRDK8sNF4Ja3BM svg[role='presentation'],
.ybVBgfOiuWZJtD:disabled:active .HRDK8sNF4Ja3BM svg[role='presentation'],
.suFfYx_LyIuG8T .cNqZwdypYCTs_6 svg[role='presentation'],
.ybVBgfOiuWZJtD:disabled .cNqZwdypYCTs_6 svg[role='presentation'],
.suFfYx_LyIuG8T:hover .cNqZwdypYCTs_6 svg[role='presentation'],
.ybVBgfOiuWZJtD:disabled:hover .cNqZwdypYCTs_6 svg[role='presentation'],
.suFfYx_LyIuG8T:active .cNqZwdypYCTs_6 svg[role='presentation'],
.ybVBgfOiuWZJtD:disabled:active .cNqZwdypYCTs_6 svg[role='presentation'],
.suFfYx_LyIuG8T .r1ljm7etlgUs0w svg[role='presentation'],
.ybVBgfOiuWZJtD:disabled .r1ljm7etlgUs0w svg[role='presentation'],
.suFfYx_LyIuG8T:hover .r1ljm7etlgUs0w svg[role='presentation'],
.ybVBgfOiuWZJtD:disabled:hover .r1ljm7etlgUs0w svg[role='presentation'],
.suFfYx_LyIuG8T:active .r1ljm7etlgUs0w svg[role='presentation'],
.ybVBgfOiuWZJtD:disabled:active .r1ljm7etlgUs0w svg[role='presentation'] {
  /* stylelint-disable-next-line declaration-no-important */
  color: unset !important;
}
.suFfYx_LyIuG8T svg circle,
.ybVBgfOiuWZJtD:disabled svg circle,
.suFfYx_LyIuG8T:hover svg circle,
.ybVBgfOiuWZJtD:disabled:hover svg circle,
.suFfYx_LyIuG8T:active svg circle,
.ybVBgfOiuWZJtD:disabled:active svg circle {
  stroke: var(--ds-text-disabled, #091e424f);
}
.orotyyeYQx_tso {
  border: none;
  background-color: var(--ds-background-brand-bold, #0c66e4);
  box-shadow: none;
  color: var(--ds-text-inverse, #ffffff);
}
.orotyyeYQx_tso .HRDK8sNF4Ja3BM [role='img'] > svg,
.orotyyeYQx_tso .cNqZwdypYCTs_6 [role='img'] > svg,
.orotyyeYQx_tso .r1ljm7etlgUs0w [role='img'] > svg,
.orotyyeYQx_tso .HRDK8sNF4Ja3BM svg[role='presentation'],
.orotyyeYQx_tso .cNqZwdypYCTs_6 svg[role='presentation'],
.orotyyeYQx_tso .r1ljm7etlgUs0w svg[role='presentation'] {
  /* stylelint-disable-next-line declaration-no-important */
  color: unset !important;
}
.orotyyeYQx_tso:hover {
  border: none;
  background-color: var(--ds-background-brand-bold-hovered, #0055cc);
  box-shadow: none;
  color: var(--ds-text-inverse, #ffffff);
  text-decoration: none;
}
.orotyyeYQx_tso:hover svg circle {
  stroke: var(--ds-text-inverse, #ffffff);
}
.orotyyeYQx_tso:active {
  border: none;
  outline: 0;
  background-color: var(--ds-background-brand-bold-pressed, #09326c);
  box-shadow: none;
  color: var(--ds-text-inverse, #ffffff);
}
.orotyyeYQx_tso:active svg circle {
  stroke: var(--ds-text-inverse, #ffffff);
}
.Bs17adKBbSQrdA {
  border: none;
  background-color: var(--ds-background-danger-bold, #ca3521);
  box-shadow: none;
  color: var(--ds-text-inverse, #ffffff);
}
.Bs17adKBbSQrdA .HRDK8sNF4Ja3BM [role='img'] > svg,
.Bs17adKBbSQrdA .cNqZwdypYCTs_6 [role='img'] > svg,
.Bs17adKBbSQrdA .r1ljm7etlgUs0w [role='img'] > svg,
.Bs17adKBbSQrdA .HRDK8sNF4Ja3BM svg[role='presentation'],
.Bs17adKBbSQrdA .cNqZwdypYCTs_6 svg[role='presentation'],
.Bs17adKBbSQrdA .r1ljm7etlgUs0w svg[role='presentation'] {
  /* stylelint-disable-next-line declaration-no-important */
  color: unset !important;
}
.Bs17adKBbSQrdA svg circle {
  stroke: var(--ds-text-inverse, #ffffff);
}
.Bs17adKBbSQrdA:hover {
  border: none;
  background-color: var(--ds-background-danger-bold-hovered, #ae2a19);
  box-shadow: none;
  color: var(--ds-text-inverse, #ffffff);
  text-decoration: none;
}
.Bs17adKBbSQrdA:hover svg circle {
  stroke: var(--ds-text-inverse, #ffffff);
}
.Bs17adKBbSQrdA:active {
  border: none;
  outline: 0;
  background-color: var(--ds-background-danger-bold-pressed, #601e16);
  box-shadow: none;
  color: var(--ds-text-inverse, #ffffff);
}
.Bs17adKBbSQrdA:active svg circle {
  stroke: var(--ds-text-inverse, #ffffff);
}
.znxMkjxGGncGJy {
  border: none;
  box-shadow: none;
  background-color: transparent;
  color: var(--ds-link, #0c66e4);
  text-decoration: underline;
  padding: var(--ds-space-0, 0);
}
.znxMkjxGGncGJy .HRDK8sNF4Ja3BM [role='img'] > svg,
.znxMkjxGGncGJy .cNqZwdypYCTs_6 [role='img'] > svg,
.znxMkjxGGncGJy .r1ljm7etlgUs0w [role='img'] > svg,
.znxMkjxGGncGJy .HRDK8sNF4Ja3BM svg[role='presentation'],
.znxMkjxGGncGJy .cNqZwdypYCTs_6 svg[role='presentation'],
.znxMkjxGGncGJy .r1ljm7etlgUs0w svg[role='presentation'] {
  /* stylelint-disable-next-line declaration-no-important */
  color: unset !important;
}
.znxMkjxGGncGJy svg circle {
  stroke: var(--ds-link, #0c66e4);
}
.znxMkjxGGncGJy:hover {
  background-color: transparent;
  color: var(--ds-link, #0c66e4);
  text-decoration: underline;
}
.znxMkjxGGncGJy:hover svg circle {
  stroke: var(--ds-link, #0c66e4);
}
.znxMkjxGGncGJy:active {
  background-color: transparent;
  color: var(--ds-link-pressed, #0055cc);
}
.znxMkjxGGncGJy:active svg circle {
  stroke: var(--ds-link-pressed, #0055cc);
}
.mUpWqmjL4CZBvn {
  border: none;
  background-color: transparent;
  box-shadow: none;
}
.mUpWqmjL4CZBvn .HRDK8sNF4Ja3BM [role='img'] > svg,
.mUpWqmjL4CZBvn .cNqZwdypYCTs_6 [role='img'] > svg,
.mUpWqmjL4CZBvn .r1ljm7etlgUs0w [role='img'] > svg,
.mUpWqmjL4CZBvn .HRDK8sNF4Ja3BM svg[role='presentation'],
.mUpWqmjL4CZBvn .cNqZwdypYCTs_6 svg[role='presentation'],
.mUpWqmjL4CZBvn .r1ljm7etlgUs0w svg[role='presentation'] {
  /* stylelint-disable-next-line declaration-no-important */
  color: unset !important;
}
.mUpWqmjL4CZBvn:hover {
  border: none;
  background-color: var(--ds-background-neutral-hovered, #091e4224);
  box-shadow: none;
  color: var(--ds-text, #172b4d);
  text-decoration: none;
}
.mUpWqmjL4CZBvn:active {
  border: none;
  outline: 0;
  background-color: var(--ds-background-neutral-pressed, #091e424f);
  box-shadow: none;
  color: var(--ds-text, #172b4d);
}
.mUpWqmjL4CZBvn:active .B9_M57XSOL8YuV {
  color: var(--ds-text, #172b4d);
}
.mUpWqmjL4CZBvn:active svg circle {
  stroke: var(--ds-text, #172b4d);
}
.O4iyCshk1noBhH {
  border: none;
  box-shadow: none;
  background-color: transparent;
  color: var(--ds-link, #0c66e4);
  text-decoration: underline;
}
.O4iyCshk1noBhH .HRDK8sNF4Ja3BM [role='img'] > svg,
.O4iyCshk1noBhH .cNqZwdypYCTs_6 [role='img'] > svg,
.O4iyCshk1noBhH .r1ljm7etlgUs0w [role='img'] > svg,
.O4iyCshk1noBhH .HRDK8sNF4Ja3BM svg[role='presentation'],
.O4iyCshk1noBhH .cNqZwdypYCTs_6 svg[role='presentation'],
.O4iyCshk1noBhH .r1ljm7etlgUs0w svg[role='presentation'] {
  /* stylelint-disable-next-line declaration-no-important */
  color: unset !important;
}
.O4iyCshk1noBhH svg circle {
  stroke: var(--ds-link, #0c66e4);
}
.O4iyCshk1noBhH:hover {
  background-color: transparent;
  color: var(--ds-link, #0c66e4);
  text-decoration: underline;
}
.O4iyCshk1noBhH:hover svg circle {
  stroke: var(--ds-link, #0c66e4);
}
.O4iyCshk1noBhH:active {
  border: none;
  outline: 0;
  background-color: var(--ds-background-neutral-pressed, #091e424f);
  box-shadow: none;
  color: var(--ds-text, #172b4d);
}
.O4iyCshk1noBhH:active .B9_M57XSOL8YuV {
  color: var(--ds-text, #172b4d);
}
.O4iyCshk1noBhH:active svg circle {
  stroke: var(--ds-text, #172b4d);
}
.fKtL8MV47M5z2x {
  border: none;
  background-color: var(--ds-background-discovery-bold, #5243aa);
  box-shadow: none;
  color: var(--ds-text-inverse, #ffffff);
}
.fKtL8MV47M5z2x .HRDK8sNF4Ja3BM [role='img'] > svg,
.fKtL8MV47M5z2x .cNqZwdypYCTs_6 [role='img'] > svg,
.fKtL8MV47M5z2x .r1ljm7etlgUs0w [role='img'] > svg,
.fKtL8MV47M5z2x .HRDK8sNF4Ja3BM svg[role='presentation'],
.fKtL8MV47M5z2x .cNqZwdypYCTs_6 svg[role='presentation'],
.fKtL8MV47M5z2x .r1ljm7etlgUs0w svg[role='presentation'] {
  /* stylelint-disable-next-line declaration-no-important */
  color: unset !important;
}
.fKtL8MV47M5z2x:hover {
  border: none;
  background-color: var(--ds-background-discovery-bold-hovered, #8777d9);
  box-shadow: none;
  color: var(--ds-text-inverse, #ffffff);
  text-decoration: none;
}
.fKtL8MV47M5z2x:hover svg circle {
  stroke: var(--ds-text-inverse, #ffffff);
}
.fKtL8MV47M5z2x:active {
  border: none;
  outline: 0;
  background-color: var(--ds-background-discovery-bold-pressed, #382d6c);
  box-shadow: none;
  color: var(--ds-text-inverse, #ffffff);
}
.fKtL8MV47M5z2x:active svg circle {
  stroke: var(--ds-text-inverse, #ffffff);
}
.znxMkjxGGncGJy:disabled,
.znxMkjxGGncGJy.suFfYx_LyIuG8T,
.mUpWqmjL4CZBvn:disabled,
.mUpWqmjL4CZBvn.suFfYx_LyIuG8T,
.O4iyCshk1noBhH:disabled,
.O4iyCshk1noBhH.suFfYx_LyIuG8T,
.znxMkjxGGncGJy:disabled:hover,
.znxMkjxGGncGJy.suFfYx_LyIuG8T:hover,
.mUpWqmjL4CZBvn:disabled:hover,
.mUpWqmjL4CZBvn.suFfYx_LyIuG8T:hover,
.O4iyCshk1noBhH:disabled:hover,
.O4iyCshk1noBhH.suFfYx_LyIuG8T:hover,
.znxMkjxGGncGJy:disabled:active,
.znxMkjxGGncGJy.suFfYx_LyIuG8T:active,
.mUpWqmjL4CZBvn:disabled:active,
.mUpWqmjL4CZBvn.suFfYx_LyIuG8T:active,
.O4iyCshk1noBhH:disabled:active,
.O4iyCshk1noBhH.suFfYx_LyIuG8T:active {
  border: none;
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: none;
  color: var(--ds-text-disabled, #091e424f);
  cursor: not-allowed;
  background-color: var(--ds-background-neutral-subtle, #00000000);
}
.znxMkjxGGncGJy:disabled svg circle,
.znxMkjxGGncGJy.suFfYx_LyIuG8T svg circle,
.mUpWqmjL4CZBvn:disabled svg circle,
.mUpWqmjL4CZBvn.suFfYx_LyIuG8T svg circle,
.O4iyCshk1noBhH:disabled svg circle,
.O4iyCshk1noBhH.suFfYx_LyIuG8T svg circle,
.znxMkjxGGncGJy:disabled:hover svg circle,
.znxMkjxGGncGJy.suFfYx_LyIuG8T:hover svg circle,
.mUpWqmjL4CZBvn:disabled:hover svg circle,
.mUpWqmjL4CZBvn.suFfYx_LyIuG8T:hover svg circle,
.O4iyCshk1noBhH:disabled:hover svg circle,
.O4iyCshk1noBhH.suFfYx_LyIuG8T:hover svg circle,
.znxMkjxGGncGJy:disabled:active svg circle,
.znxMkjxGGncGJy.suFfYx_LyIuG8T:active svg circle,
.mUpWqmjL4CZBvn:disabled:active svg circle,
.mUpWqmjL4CZBvn.suFfYx_LyIuG8T:active svg circle,
.O4iyCshk1noBhH:disabled:active svg circle,
.O4iyCshk1noBhH.suFfYx_LyIuG8T:active svg circle {
  stroke: var(--ds-text-disabled, #091e424f);
}
.JjWtyAi4N6CDgu {
  padding: var(--ds-space-075, 6px) var(--ds-space-300, 24px);
}
.Y8VSmRstKSzhJH {
  width: 100%;
}
.Wx2Cn8sNDLjtwO {
  padding-top: var(--ds-space-050, 4px);
  padding-bottom: var(--ds-space-050, 4px);
}
.qPwgTUbeFFACen {
  background: var(--ds-background-neutral-bold-hovered, rgba(0, 0, 0, 0.8));
  color: var(--ds-text-inverse, #ffffff);
}
.qPwgTUbeFFACen:hover,
.qPwgTUbeFFACen:focus,
.qPwgTUbeFFACen:active {
  background: var(--ds-background-neutral-bold, rgba(0, 0, 0, 0.7));
  color: var(--ds-text-inverse, #ffffff);
}
`, ""]);
// Exports
var _1 = `ybVBgfOiuWZJtD`;
export { _1 as "nch-button" };
export var iconBefore = `HRDK8sNF4Ja3BM`;
export var iconAfter = `cNqZwdypYCTs_6`;
export var iconOnly = `r1ljm7etlgUs0w`;
var _2 = `Yt_v_LmarJM9ZS`;
export { _2 as "nch-button__iconButton" };
var _3 = `B9_M57XSOL8YuV`;
export { _3 as "icon-sm" };
var _4 = `_St8_YSRMkLv07`;
export { _4 as "nch-button__isReactButtonComponent" };
export var focusVisible = `jtCJZNTEQmaYhu`;
var _5 = `suFfYx_LyIuG8T`;
export { _5 as "nch-button--disabled" };
var _6 = `orotyyeYQx_tso`;
export { _6 as "nch-button--primary" };
var _7 = `Bs17adKBbSQrdA`;
export { _7 as "nch-button--danger" };
var _8 = `znxMkjxGGncGJy`;
export { _8 as "nch-button--link" };
var _9 = `mUpWqmjL4CZBvn`;
export { _9 as "nch-button--subtle" };
var _a = `O4iyCshk1noBhH`;
export { _a as "nch-button--subtleLink" };
var _b = `fKtL8MV47M5z2x`;
export { _b as "nch-button--discovery" };
var _c = `JjWtyAi4N6CDgu`;
export { _c as "nch-button--wide" };
var _d = `Y8VSmRstKSzhJH`;
export { _d as "nch-button--fullwidth" };
var _e = `Wx2Cn8sNDLjtwO`;
export { _e as "nch-button--loading" };
var _f = `qPwgTUbeFFACen`;
export { _f as "nch-button--selected" };
export default ___CSS_LOADER_EXPORT___;
